<template lang="pug">
	div.contenedor(ref="contenedor", :style="{height: alto + 'px'}")
		.row
			.col.text-left
				.input-group.mb-2
					.input-group-prepend
						.input-group-text Emisora
					input-query(
						:realtime="true"
						url="control-emisoras/php/api/queryEmisora.php"
						@selected="seleccionaEmisora($event)"
						input-class="form-control"
						placeholder="Selecciona una emisora"
						v-if="!emisora"
					)
					input.form-control(v-else, :value="emisora.Nombre", disabled)
					.input-group-append(v-if="emisora")
						button.btn.btn-danger(@click="quitarEmisora")
							span.fa.fa-trash
			.col
				.input-group
					.input-group-prepend
						.input-group-text Cobertura mínima
					input.form-control(v-model.number="filtro.CoberturaMinima", @keypress.enter="getCoberturas", @keypress="limpiarMapa")
					.input-group-prepend.input-group-append
						.input-group-text Cobertura máxima
					input.form-control(v-model.number="filtro.CoberturaMaxima", @keypress.enter="getCoberturas", @keypress="limpiarMapa")
					.input-group-append
						button.btn.btn-primary(@click="getCoberturas()")
							span.fa.fa-search.mr-2
							| Buscar
		div(id="map")
</template>

<script>
const iconBase = 'https://sip.radiocastellon.com/src/modulos/control-emisoras/static/png/'
export default {
	data () {
		return {
			alto: null,
			emisora: null,
			listado: [],
			filtro: {
				emisoras: [],
				CoberturaMinima: 0,
				CoberturaMaxima: 5
			},
			marcadores: [],
			heatmap: null,
			iconos: {
				0: {
					icon: iconBase + 'zero.png'
				},
				1: {
					icon: iconBase + 'one.png'
				},
				2: {
					icon: iconBase + 'two.png'
				},
				3: {
					icon: iconBase + 'three.png'
				},
				4: {
					icon: iconBase + 'four.png'
				},
				5: {
					icon: iconBase + 'five.png'
				},
				6: {
					icon: iconBase + 'six.png'
				},
				7: {
					icon: iconBase + 'seven.png'
				},
				8: {
					icon: iconBase + 'eight.png'
				},
				9: {
					icon: iconBase + 'nine.png'
				},
				10: {
					icon: iconBase + 'ten.png'
				}
			}
		}
	},
	created () {
		// Calculamos las dimensiones
		this.calcular()
		window.addEventListener('resize', this.calcular)
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.calcular)
	},
	mounted () {
		const initMap = () => {
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('map'), {
				center: {lat: 39.986038, lng: -0.036070},
				zoom: 12,
				zoomControl: false,
				minZoom: 11,
				maxZoom: 13
			})
		}
		initMap()
	},
	methods: {
		calcular () {
			this.alto = window.innerHeight - 120
		},
		quitarEmisora () {
			this.emisora = null
		},
		seleccionaEmisora (ev) {
			this.emisora = ev.datos
			this.filtro.emisoras = [ev.datos.EmisoraID]
			this.getCoberturas()
		},
		limpiarMapa (cb) {
			for (let i = 0; i < this.marcadores.length; i++) {
				this.marcadores[i].setMap(null)
			}

			if (this.heatmap) {
				this.heatmap.setMap(null)
			}

			if (cb) {
				window.setTimeout(() => {
					cb()
				}, 100)
			}
		},
		getCoberturas (ev) {
			if (!this.emisora) {
				this.$error('Error', 'Selecciona una emisora')
				return
			}
			if (typeof this.filtro.CoberturaMinima !== 'number' || this.filtro.CoberturaMinima < 0 || this.filtro.CoberturaMinima > 10) {
				this.$error('Error', 'La cobertura mínima debe ser un número entre 0 y 10')
				return
			}

			if (typeof this.filtro.CoberturaMaxima !== 'number' || this.filtro.CoberturaMaxima < 0 || this.filtro.CoberturaMaxima > 10) {
				this.$error('Error', 'La cobertura máxima debe ser un número entre 0 y 10')
				return
			}

			const form = JSON.parse(JSON.stringify(this.filtro))
			form.CoberturaMinima = (typeof form.CoberturaMinima === 'number') ? form.CoberturaMinima * 10 : 0
			form.CoberturaMaxima = (typeof form.CoberturaMaxima === 'number') ? form.CoberturaMaxima * 10 : 100

			this.limpiarMapa(() => {
				this.$http.post('control-emisoras/php/api/buscar.php', form)
					.then(res => {
						const resultados = res.data.filter(r => {
							return (r.latitud && r.longitud)
						}).map(r => {
							const puntuacion = Math.round(r.calidad)
							r.Icono = puntuacion
							r.Nombre = r.municipio
							const pos = {
								// eslint-disable-next-line
								position: new google.maps.LatLng(r.latitud, r.longitud),
								Nombre: r.Nombre,
								type: r.Icono,
								weight: r.calidad
							}
							return pos
						})

						const heatmapData = resultados.reduce((accum, result) => {
							const data = {
								location: result.position,
								weight: result.weight
							}
							accum.push(data)
							return accum
						}, [])
						/*
						for (let i = 0; i < resultados.length; i++) {
							// eslint-disable-next-line
							this.marcadores.push(new google.maps.Marker({
								position: resultados[i].position,
								icon: this.iconos[resultados[i].type].icon,
								title: resultados[i].Nombre,
								map: this.map
							}))
						}
						*/
						// eslint-disable-next-line no-undef
						this.heatmap = new google.maps.visualization.HeatmapLayer({
							data: heatmapData,
							radius: 20
						})
						this.heatmap.setMap(this.map)
					})
					.catch(e => {
						console.error(e)
						this.$responseError(e)
					})
			})
		}
	}
}
</script>


<style scoped>
#map {
    height: 100%;
  }
.contenedor {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modulos/control-emisoras/vue/components/mapa/mapa.vue